<template>
  <v-layout wrap pt-md-5 pb-12 px-md-12>
     <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <v-flex
      xs12
      text-center
      px-md-12
      pb-3
      py-sm-3
      py-md-6
      style="font-size: 30px; font-family: robotobold"
    >
      HiveKeep Blog
    </v-flex>
    <v-flex xs12 px-md-12>
      <v-layout wrap>
        <v-flex
          align-self-center
          text-center
          px-2
          px-lg-2
          xs12
          md4
          v-for="(item, i) in blog"
          :key="i"
        >
          <v-card flat>
            <v-layout wrap style="font-family: robotoregular">
              <v-flex xs12>
                <v-img :src="mediaURL + item.photo"> </v-img>
              </v-flex>
              <v-flex class="texttt" px-3 px-md-0 xs12 text-left style="font-size: 15px" pt-2>
                {{ item.heading }}
              </v-flex>
              <v-flex
                px-3
                px-md-0
                xs6
                text-left
                style="color: #ababab; font-size: 12px; font-family: sofiapro"
              >
                {{ item.create_date.slice(0, 10) }}
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        <v-layout justify-end wrap>
          <router-link
            style="text-decoration: none; color: black"
            :to="'/blog'"
          >
            <v-flex
              pr-3
              px-md-0
              xs12
              text-right
              pr-md-5
              style="
                color: #ababab;
                font-size: 10px;
                font-family: sofiapro;
                cursor: pointer;
              "
            >
              Read More
            </v-flex>
          </router-link>
        </v-layout>
      </v-layout>
    </v-flex>
  </v-layout>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      blog: [],
      appLoading:false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/blog/list",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            var temp = [];
            temp = response.data.data;
            if (temp.length > 3) {
              this.blog = temp.slice(0, 3);
            } else {
              this.blog = response.data.data;
            }
            // this.blog = response.data.data;
            this.pages = response.data.pages;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
.texttt {
  line-height: 1.5em;
  min-height: 4.5em;
  float: left;
}
</style>